import { UTMCookieSettingsType } from '@landr/core';
import { CONFIG } from '../utils/config';

export const UTMCookieSettings: UTMCookieSettingsType = {
    secure: CONFIG.VITE_SECURE_COOKIES === 'true',
    expires: 30,
    domain: CONFIG.VITE_COOKIE_DOMAIN,
};
